export { default } from './Normal';
